import React from 'react';
import propTypes from 'prop-types';

const Links = props => {
  const items = props.links.map((link, index) => {
    const linkClassName = index === 0 ? 'button' : 'button button--outline';
    return (
      <React.Fragment>
        <a href={link.url} className={linkClassName}>
          {link.displayText}
        </a>
      </React.Fragment>
    );
  });

  return <div className="scalable-content-section__links">{items}</div>;
};

Links.propTypes = {
  links: propTypes.array.isRequired,
};

export default Links;
